import { cx } from '@emotion/css';
import { pxToRem } from '@mos-cat/ds-theme';
import { createComponent, createHook } from 'reakit-system';
import type { BoxHTMLProps, BoxProps } from '../Box/Box';
import { Box } from '../Box/Box';
import { useIsland } from '../Island/Island';
import { Spinner, SpinnerWrapper } from '../Loader/Loader';
import { Paragraph } from '../Paragraph/Paragraph';
import { useStyles } from '../hooks';
import { ecss } from '../reexports/emotion';

const useLoaderIsland = createHook<BoxProps, BoxHTMLProps>({
  keys: ['textContent'],
  compose: [useIsland, useStyles],
  useOptions(options) {
    return {
      my: ['sp-8', 'sp-24'],
      minHeight: [pxToRem(272), pxToRem(296)],
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      flexDirection: 'column',
      size: 'size-1',
      styles: {
        textAlign: 'center',
        ':focus': {
          outline: 'none',
        },
      },
      ...options,
    };
  },
  useProps(_, props) {
    return {
      ...props,
      children: (
        <>
          <SpinnerWrapper iconSize={pxToRem(40)} color="loaderColor">
            <Spinner />
          </SpinnerWrapper>
          <Box mt="sp-24">
            {props.children ? (
              props.children
            ) : (
              <Paragraph>Идет загрузка</Paragraph>
            )}
          </Box>
        </>
      ),
      className: cx(props.className, ecss({ label: 'LoaderIsland' })),
    };
  },
});

export const LoaderIsland = createComponent({
  as: 'div',
  useHook: useLoaderIsland,
});
